<template>
  <v-container fluid>
    <v-row>
      <v-col
        v-for="item in items"
        :key="item.title"
        md="12"
      >
        <SubjectCard
          :title="item.title"
          :type="item.type"
          :subject="item.subject"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import SubjectCard from './SubjectCard.vue';

export default {
  components: {SubjectCard},
  computed: {
    ...mapGetters(['featureSubject','attentionSubject']),
    ...mapState({
      items: state => [
        {
          title: 'Destaque',
          type: 'success',
          subject: state.metric.featureSubject,
        },
        {
          title: 'Atenção',
          type: 'danger',
          subject: state.metric.attentionSubject,
        }
      ]
    })
  },
  created(){
    this.getFeatureSubject();
    this.getAttentionSubject();
  },
  methods:{
    ...mapActions([
      'getFeatureSubject',
      'getAttentionSubject',
    ])
  },

}
</script>
